export default __webpack_public_path__ + "static/media/light.e60aef16.svg";